import { ImageSet } from '@bloomreach/spa-sdk';
import { getImageSetWithVariants } from '../brx/data';

const variants = [
  'original',
  'thumbnail',
  'extralarge',
  'extrasmall',
  'featuredlarge',
  'featuredmedium',
  'featuredsmall',
  'small',
  'medium',
  'large',
  'preloader',
];

const resolveImageReference = ({ rawVal, page }: PropsWithCMSProps<ImageReferenceProps>) => {
  if (!rawVal) return undefined;

  const imageSet = getImageSetWithVariants({
    imageSet: page?.getContent<ImageSet>(rawVal),
    variants,
  });

  const resolveImageVariant = (variant: string) => {
    const img = imageSet?.getVariant(variant) as any;

    if (img?.model) {
      const { width, height, size, links } = img.model;
      return { width, size, height, url: links.site?.href };
    }

    return null;
  };

  return {
    original: resolveImageVariant('original'),
    thumbnail: resolveImageVariant('thumbnail'),
    extraLarge: resolveImageVariant('extralarge'),
    extraSmall: resolveImageVariant('extrasmall'),
    featuredLarge: resolveImageVariant('featuredlarge'),
    featuredMedium: resolveImageVariant('featuredmedium'),
    featuredSmall: resolveImageVariant('featuredsmall'),
    small: resolveImageVariant('small'),
    medium: resolveImageVariant('medium'),
    large: resolveImageVariant('large'),
    preloader: resolveImageVariant('preloader'),
  } as ImageType;
};

export default resolveImageReference;
